import { useTranslation } from "react-i18next";
import { Button, Typography } from "@mui/material";
import { Page } from "@/components/Page";

export const Err404 = () => {
  const { t } = useTranslation();

  return (
    <Page title="404">
      <Typography variant="body1" style={{ marginTop: "1rem" }}>
        {t("The page you are looking for might have been removed, had its url changed or is temporarily unavailable.")}
      </Typography>
      <Button type="submit" variant="contained" color="primary" fullWidth sx={{ marginTop: "2rem" }} href="/">
        {t("Go to Home")}
      </Button>
    </Page>
  );
};
